import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalCompaniesState,
  IGlobalCompanyContactsState,
  IGlobalConfigurationState,
  IGlobalSocialNetworksState,
  selectCompanyContacts,
  selectCompanyList,
  selectConfiguration,
  selectSocialNetworks,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import PropertyEdit from '../components/PropertyEdit'
import {
  actionCreators,
  IPropertyEditState,
  selectCanSave,
  selectError,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectProperty,
} from '../modules/propertyEdit'

type IComponentState = IPropertyEditState &
  ICurrentUserState &
  IGlobalCompanyContactsState &
  IGlobalConfigurationState &
  IGlobalSocialNetworksState &
  IGlobalCompaniesState

export default connect(
  createStructuredSelector<ApplicationState, IComponentState>({
    companies: selectCompanyList(),
    companyContacts: selectCompanyContacts(),
    configuration: selectConfiguration(),
    socialNetworks: selectSocialNetworks(),
    user: selectCurrentUser(),
    error: selectError(),
    isLoading: selectIsLoading(),
    isReady: selectIsReady(),
    isSaving: selectIsSaving(),
    property: selectProperty(),
    canSave: selectCanSave(),
  }),
  actionCreators,
)(PropertyEdit)
